/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.dashboard[_ngcontent-%COMP%] {\n  height: 100%;\n  width: 100%;\n  overflow: auto;\n  box-sizing: border-box;\n  background-color: #F1F1F1;\n  margin-top: 0;\n  padding-top: 0; }\n\n.progressPlaceholderBG[_ngcontent-%COMP%] {\n  background-color: white;\n  margin: 0; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL21haW4vZGFzaGJvYXJkLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy91aS9zcmMvYXBwL21haW4vZGFzaGJvYXJkLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./aot_output/src/app/main/dashboard.component.scss.shim.ngstyle.ts